import XlsxTemplateOriginal from 'xlsx-template-browserify';
import {saveByteArray} from '../docx/base';
import { fix } from './lib-fix';
import { polyFetch } from '../../api';

class XlsxTemplate extends XlsxTemplateOriginal {
    
};

const loadTemplate = (url) => {
    return new Promise((resolve, reject) => {
        polyFetch(url).then(resp => resp.arrayBuffer()).then(res => resolve(new XlsxTemplate(res)));
    });
};

export const buildXlsx = (templateUrl, data, filename, { preproc = null, postproc = null }) => {
    loadTemplate(templateUrl).then(template => {
        fix(template);
        if (preproc)
            preproc(template);
        template.substitute(1, data);
        if (postproc)
            postproc(template);
        saveByteArray([template.generate({type: 'arraybuffer'})], filename);
    }).catch((error) => {
        console.log('buildXlsx error: ' + error.message);
    });
};
